import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export async function exportCockpitPDF(industry) {
  const el = document.querySelector('[data-testid="executive-cockpit"]');
  if (!el) return;

  // Show generating indicator
  const overlay = document.createElement('div');
  overlay.id = 'pdf-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(26,32,21,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;';
  overlay.innerHTML = '<div style="background:white;padding:24px 40px;border-radius:12px;text-align:center;font-family:Manrope,sans-serif"><p style="font-size:14px;font-weight:600;color:#1A2015">Generating Board Pack...</p><p style="font-size:12px;color:#888864;margin-top:4px">This may take a few seconds</p></div>';
  document.body.appendChild(overlay);

  try {
    const canvas = await html2canvas(el, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#F7F7F6',
      logging: false,
      windowWidth: 1280,
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    // Header
    pdf.setFillColor(26, 32, 21);
    pdf.rect(0, 0, pdfWidth, 20, 'F');
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(14);
    pdf.setTextColor(255, 255, 255);
    pdf.text('SusTek EESG Control Tower — Executive Board Pack', 10, 13);

    pdf.setFontSize(9);
    pdf.setTextColor(163, 163, 128);
    pdf.text(`${industry} | Generated ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`, pdfWidth - 10, 13, { align: 'right' });

    // Content
    const imgWidth = pdfWidth - 16;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const maxImgHeight = pdfHeight - 32;

    if (imgHeight <= maxImgHeight) {
      pdf.addImage(imgData, 'PNG', 8, 24, imgWidth, imgHeight);
    } else {
      // Multi-page
      let yOffset = 0;
      let pageNum = 0;
      const totalContentHeight = canvas.height;
      const pixelsPerPage = (maxImgHeight / imgWidth) * canvas.width;

      while (yOffset < totalContentHeight) {
        if (pageNum > 0) {
          pdf.addPage();
          pdf.setFillColor(26, 32, 21);
          pdf.rect(0, 0, pdfWidth, 14, 'F');
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(8);
          pdf.setTextColor(163, 163, 128);
          pdf.text(`SusTek Board Pack — ${industry} — Page ${pageNum + 1}`, 10, 9);
        }

        const sliceCanvas = document.createElement('canvas');
        sliceCanvas.width = canvas.width;
        const sliceHeight = Math.min(pixelsPerPage, totalContentHeight - yOffset);
        sliceCanvas.height = sliceHeight;

        const ctx = sliceCanvas.getContext('2d');
        ctx.drawImage(canvas, 0, yOffset, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight);

        const sliceData = sliceCanvas.toDataURL('image/png');
        const renderHeight = (sliceHeight * imgWidth) / canvas.width;
        const yStart = pageNum === 0 ? 24 : 18;

        pdf.addImage(sliceData, 'PNG', 8, yStart, imgWidth, renderHeight);

        yOffset += pixelsPerPage;
        pageNum++;
      }
    }

    // Footer on last page
    pdf.setFontSize(7);
    pdf.setTextColor(136, 136, 100);
    pdf.text('CONFIDENTIAL — SusTek EESG Control Tower & Digital Twin', 10, pdfHeight - 5);
    pdf.text('Generated by AI-Powered Decision Platform', pdfWidth - 10, pdfHeight - 5, { align: 'right' });

    pdf.save(`SusTek_BoardPack_${industry.replace(/\s+/g, '_')}_${new Date().toISOString().slice(0, 10)}.pdf`);
  } catch (err) {
    console.error('PDF export failed:', err);
  } finally {
    const o = document.getElementById('pdf-overlay');
    if (o) o.remove();
  }
}
